@if (ready()) {
    <div class="page">
        <!-- top bar -->
        <section class="top-bar">
            <!-- title -->
            <h1 class="">API keys </h1>
    
            <div class="d-flex align-items-center">
                <!-- overview -->
                <a [href]="appOverviewUrl" class="d-flex align-items-center portal-link">
                    <i class="im-icon im-icon-portal-dots"></i>
                </a>
                <!-- profile right -->
                <div class="profile-wrap d-flex align-items-center">
                    <app-profile-section></app-profile-section>
                </div>
            </div>
        </section>
        <!-- end top bar -->
    
        <section style="max-width: 920px;">
        <div>
                <p class="mb-4">Voeg API key toe. Hierbij ook de link naar de online technische handleiding:</p>
                <div class="d-flex gap-4 align-items-center">
                    <a href="https://www.meldpuntmedicijnen.nl/api-docs/" target="_blank" class="button-link fontsize-s d-flex gap-1 text-decoration-none"><span>OpenAPI specificaties</span><i class="im-icon im-icon-link-external"></i></a>
                    
                    <a [routerLink]="['new']" class="ml-auto button default text-decoration-none" [disabled]="loading() || submitting()" [class.submitting]="submitting()" >
                        <i class="im-icon im-icon-plus-round"></i>
                        <span>API key toevoegen</span>
                    </a>
                </div>
            </div>
    
            <div class="mt-4 saving--pre" [class.saving]="loading() || submitting()">
                <div class="d-flex flex-column gap-3">
                    @for (key of apiKeys(); track key.id) {
                        <div class="api-key">
                            <div class="name display-content d-flex flex-column">
                                <span class="display-label">Klant</span>
                                <span class="display-value">{{key.klant}}</span>
                            </div>
                            <div class="secret display-content d-flex flex-column">
                                <span class="display-label">API key</span>
                                <span class="display-value d-flex gap-2">@for (dot of apiKeyPlaceholder; track $index) { <span class="bullet"></span> }</span>
                            </div>
                            <div class="position-relative ml-auto align-self-center" >
                                <button (click)="deleteApiKeyId.set(key.id); $event.stopPropagation()" class="button-link fontsize-s red" [disabled]="loading() || submitting()">Verwijderen</button>
                                @if (deleteApiKeyId() === key.id) {
                                    <app-confirm-delete appClickOutside (clickOutside)="deleteApiKeyId.set(undefined)" (confirm)="deleteKey(deleteApiKeyId()); deleteApiKeyId.set(undefined)" (cancel)="deleteApiKeyId.set(undefined);" [open]="true" [title]="'Weet je het zeker?'" [descr]="'Weet je zeker dat je deze API key wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden.'" positionClass="left" positionClassV="top" />
                                }
    
                            </div>
                        </div>
                    } @empty {
                        <span class="gray">Er zijn geen api-keys</span>
                    }
                </div>

            </div>
        </section>
    
        
    </div>
}
@else {
    <app-spinner [centerVertically]="true"></app-spinner>

}


<router-outlet />